import { TableHead, TableRow } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { DataTableHeaderCell } from "./data-table-header-cell"

export function DataTableHeader({ columns }) {
    return (
        <TableHead>
            <TableRow data-cy="data-table-header-row">
                <Repeat list={columns} item={<DataTableHeaderCell />} keyFn="field" />
            </TableRow>
        </TableHead>
    )
}
